module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-overlay', {
    attrs: {
      "show": _vm.certLoading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.certLoading),
      callback: function($$v) {
        _vm.certLoading = $$v
      },
      expression: "certLoading"
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.certshow),
      callback: function($$v) {
        _vm.certshow = $$v
      },
      expression: "certshow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.appDownload(_vm.filename, _vm.certUrl)
      }
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'MyClub'
      }),
      expression: "{name:'MyClub'}"
    }],
    on: {
      "click": _vm.toMyClub
    }
  }, [_c('van-notice-bar', {
    attrs: {
      "text": "您已具备申请二星俱乐部资质，请尽快升级俱乐部资质。点击前往>>"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), (_vm.row.station.pay_qrcode.length > 0) ? _c('div', {
    staticClass: "desc"
  }, [_vm._v("\n        如果您还未缴纳费用，请扫以下二维码码支付费用" + _vm._s(_vm.row.order.pay_price) + "元。请勿重复缴费！！！\n        \n        "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "color": "rgb(255, 255, 255)",
      "background": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "border": "0px"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.beizhu()
      }
    }
  }, [_vm._v("支付成功后，请点这里上传支付凭证\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, _vm._l((_vm.row.station.pay_qrcode), function(picval, picindex) {
    return _c('img', {
      key: picindex,
      attrs: {
        "src": picval.url,
        "alt": ""
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.station.gametype != 3),
      expression: "row.station.gametype != 3"
    }],
    staticClass: "desc"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("【重要】请仔细阅读下列说明")]), _vm._v(" "), (_vm.row.station_name.indexOf('会议') == -1) ? _c('p', [_vm._v("1、报名成功后，请务必添加下方培训专属群！")]) : _c('p', [_vm._v("请务必添加所参加会议的群二维码，后续所有参会信息将统一在群中发布。")]), _vm._v(" "), _c('p', [_vm._v("加群方式：长按二维码图片或截图后保存至相册→打开微信→点击右上角“+”号→点击“扫一扫”→点击“相册”→选中相应图片")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.station.is_online == 1),
      expression: "row.station.is_online == 1"
    }]
  }, [_vm._v("\n          2、本次培训含有线上培训内容，啦啦之星平台为指定培训课程平台，请用微信扫描下课程兑换码（本码仅限观看课程《全国啦啦操新周期培训课程》，并非啦啦之星VIP年费会员），方可开始学习；注意：请在有效期内兑换，请用本人微信扫码兑换，一人一码，任何转借、外发，恕不再补；")])])]), _vm._v(" "), (_vm.row.saiqu == 692) ? _c('div', [(_vm.checkImg('全国啦啦操七彩星级工作会议')) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-6.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("请扫上方二维码进入【七彩星级会议】的群二维码")])]) : _vm._e(), _vm._v(" "), (_vm.checkImg('省、市级啦啦操协会工作会议')) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-8.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("请扫上方二维码进入【省、市级协会会议】的群二维码")])]) : _vm._e(), _vm._v(" "), (_vm.checkImg('啦啦操校（局）长工作会议')) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-10.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("请扫上方二维码进入【校局长论坛】的群二维码")])]) : _vm._e(), _vm._v(" "), (_vm.checkImg('省、市级啦啦操协会工作会议')) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1742807684953-12.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("请扫上方二维码进入【省级管理单位会议】的群二维码")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.row.erweiimg.length > 0 && _vm.row.saiqu != 692) ? _c('div', {
    staticClass: "order-success"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.erweiimg[0].url
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫码加工作人员好友，进入培训微信群")])]) : _vm._e(), _vm._v(" "), (_vm.row.wechat_erweiimg.length > 0 && _vm.row.saiqu != 692) ? _c('div', {
    staticClass: "order-success"
  }, [_c('p', [_vm._v("扫码进入微信群")]), _vm._v(" "), _vm._l((_vm.row.wechat_erweiimg), function(wechat_erweiimg_url, wechat_erweiimg_key) {
    return _c('p', {
      key: wechat_erweiimg_key,
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "70%"
      },
      attrs: {
        "src": wechat_erweiimg_url
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("场次信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "场次",
      "value": _vm.row.station_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "时间",
      "value": _vm.row.station.startdate + '至' + _vm.row.station.enddate
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "地点",
      "value": _vm.row.station.province + '  ' + _vm.row.station.city + ' ' + _vm.row.station.county
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("个人信息")]), _vm._v(" "), _vm._l((_vm.row.member_list), function(membervalue, memberindex) {
    return _c('van-cell-group', {
      key: memberindex
    }, [_c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "省市区",
        "value": _vm.row.province + '  ' + _vm.row.city + ' ' + _vm.row.county + ' ' + _vm.row.address
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "姓名",
        "value": membervalue.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "身份证号",
        "value": membervalue.num
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "手机号",
        "value": membervalue.phone
      }
    }), _vm._v(" "), (membervalue.need_jie == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "接站时间",
        "value": membervalue.jie_date
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_jie == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "接站车次/航班号",
        "value": membervalue.jie_code
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_song == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "送站时间",
        "value": membervalue.song_date
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.need_song == 1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "送站车次/航班号",
        "value": membervalue.song_code
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.chengji) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "成绩",
        "value": membervalue.chengji
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.score1) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "title": "教练考核成绩",
        "is-link": membervalue.score1 > 60,
        "value": membervalue.score1
      },
      on: {
        "click": function($event) {
          return _vm.showCert(membervalue, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (membervalue.score2) ? _c('van-cell', {
      attrs: {
        "input-align": "right",
        "is-link": membervalue.score1 > 60,
        "title": "裁判考核成绩",
        "value": membervalue.score2
      },
      on: {
        "click": function($event) {
          return _vm.showCert(membervalue, 2)
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(1)
      }
    }
  }, [_vm._v("通知文件下载\n      ")]), _vm._v(" "), (_vm.row.station.is_daoshi == 1) ? _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goFiles(2)
      }
    }
  }, [_vm._v("导师团\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.row.file_upload_url) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.fileUrlShow = true
      }
    }
  }, [_vm._v("上传报告PPT\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [(_vm.row.station.course_id > 0 || _vm.row.station.course_cate_id > 0) ? _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goCourse()
      }
    }
  }, [_vm._v("线上课程学习\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [(_vm.row.station.can_exame == 1) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiExame',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'HuiyiExame' ,query:{ id:row.id }}"
    }],
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("在线考试\n      ")]) : _vm._e(), _vm._v(" "), (_vm.row.station.need_video == 1) ? _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyFormUploadVideo',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'HuiyiApplyFormUploadVideo' ,query:{ id:row.id }}"
    }],
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("上传视频\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.row.station.zips.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadZips()
      }
    }
  }, [_vm._v(_vm._s(_vm.row.station.zips[0].name) + "下载\n      ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.row.station.exame_list), function(examevalue, examekey) {
    return _c('div', {
      key: examekey
    }, [_c('van-divider', [_vm._v("在线考试" + _vm._s(examekey + 1))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px",
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem",
        "margin": "0 auto"
      },
      attrs: {
        "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
        "size": "normal",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.goExame(examevalue)
        }
      }
    }, [_vm._v(_vm._s(examevalue.name) + "\n           ")]), _vm._v(" "), (examevalue.need_video) ? _c('van-button', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'HuiyiApplyFormExameUploadVideo',
          query: {
            id: _vm.row.id,
            index: examekey + 1
          }
        }),
        expression: "{name:'HuiyiApplyFormExameUploadVideo' ,query:{ id:row.id ,index:examekey+1}}"
      }],
      staticStyle: {
        "width": "3rem",
        "margin": "0 auto"
      },
      attrs: {
        "size": "normal",
        "round": ""
      }
    }, [_vm._v("上传视频\n      ")]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.row.learn_erweima) ? _c('div', {
    staticClass: "order-success"
  }, [(_vm.row.erweiimg.length > 0) ? _c('p', [_vm._v("扫码进入小程序,在线学习")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.learn_erweima
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.row.cert_url && _vm.row.cert_url.url) ? _c('div', {
    staticClass: "cert-li"
  }, [_c('van-divider', [_vm._v("结业证书")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.row.cert_url.url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cert-button"
  }, [(!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存\n        ")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.appDownload(_vm.row.cert_url.filename, _vm.row.cert_url.url)
      }
    }
  }, [_vm._v("点击下载\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyList'
      }),
      expression: "{name:'HuiyiApplyList'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("我的报名记录\n      ")])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请在复制网址到电脑端操作",
      "confirm-button-text": "关闭"
    },
    model: {
      value: (_vm.fileUrlShow),
      callback: function($$v) {
        _vm.fileUrlShow = $$v
      },
      expression: "fileUrlShow"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0",
      "line-height": "30px"
    }
  }, [_c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.file_upload_url),
      expression: "row.file_upload_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.row.file_upload_url) + "  "), _c('br'), _vm._v(" "), _c('span', [_vm._v("复制")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6640dac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormSuccess.vue
// module id = 2589
// module chunks = 0